"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    backgroundColor: "inherit",
    display: "flex",
    margin: theme.spacing(-0.5)
  },
  button: {
    padding: theme.spacing(0.5)
  },
  icon: {
    fontSize: "18px",
    marginRight: theme.spacing(1)
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    fontWeight: "bold"
  }
}));

const ToolbarButton = ({
  icon,
  label,
  title,
  onClick
}) => {
  const classes = useStyles();
  return _react.default.createElement(_ButtonBase.default, {
    className: classes.button,
    onClick: onClick
  }, icon && _react.default.createElement("i", {
    className: classes.icon
  }, _react.default.createElement(_Icon.default, null, icon)), _react.default.createElement("b", {
    className: classes.label
  }, label || title));
};

const FinderToolbar = ({
  buttons = []
}) => {
  const classes = useStyles();

  if (!buttons.length) {
    return null;
  }

  return _react.default.createElement("nav", {
    className: classes.root
  }, buttons.map((button, index) => {
    return _react.default.createElement(ToolbarButton, _extends({}, button, {
      key: index
    }));
  }));
};

var _default = FinderToolbar;
exports.default = _default;
module.exports = exports.default;